import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { GET_SITE_SUBSCRIPTION_DETAILS } from './url-constants';

type GetSiteSubscriptionEndpointSpecification = ApiEndpointSpecification;
export const GetSiteSubscriptionEndpointSpecification: GetSiteSubscriptionEndpointSpecification = {
    url: GET_SITE_SUBSCRIPTION_DETAILS,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'GetSiteSubscriptionRequestParams',
    requestBodySchemaName: 'GetSiteSubscriptionRequestBody',
    okResponseSchemaName: 'GetSiteSubscriptionOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    //version: 3,
};

export const invokeGetSiteSubscriptionDetails = Helpers.makeApiRequestFn<
    Types.GetSiteSubscriptionRequestParams,
    Types.GetSiteSubscriptionRequestBody,
    Types.GetSiteSubscriptionOkResponse
>(GetSiteSubscriptionEndpointSpecification);
